export default "__VITE_ASSET__DjBPrsqE__"